import SupportEmailText from '../components/help/SupportEmailText'
import PageMasthead from '../components/PageMasthead'
import { TextPageContainer } from '../containers/TextPageContainer'

/**
 * This page is used to add a Facebook account to Arwen.
 */
function InstagramProfileConfigurationHelpPage() {
    return (
        <>
            <PageMasthead
                title="How to configure your Instagram profile so you can connect it to Arwen"
                tabTitle="How to configure your Instagram profile so you can connect it to Arwen"
            />
            <TextPageContainer>
                <div className="w-full flex justify-center">
                    <iframe
                        className="w-full h-64 sm:h-96 lg:h-112 xl:h-128 border-0"
                        src="https://www.youtube.com/embed/WWWsI_uOpZg?si=y2SLMactDMAkAgxB"
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                        allowFullScreen
                    ></iframe>
                </div>
                <div className="mt-6">
                    <SupportEmailText />
                </div>
            </TextPageContainer>
        </>
    )
}

export default InstagramProfileConfigurationHelpPage
